import React from "react";
import { NavLink } from "react-router-dom";
const LinkAdapter = React.forwardRef((props, ref) => {
    return (React.createElement(NavLink, { to: props.href, innerRef: ref, className: props.className, onClick: props.onClick }, props.children));
});
export default LinkAdapter;
